import clsx from "clsx"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"

import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import formatDuration from "@utils/formatDuration"

import { Table } from "@organisms"

import styles from "./NumericalDataCell.module.scss"
import { NumericalDataCellProps } from "./NumericalDataCell.types"

dayjs.extend(duration)

export default function NumericalDataCell(props: NumericalDataCellProps) {
    const { value, type = "number", unitType, ignoreZero = false, isAlerting } = props

    const { formatCurrency } = useCurrencyFormatters()

    const isNoValue = (!value && value !== 0) || (ignoreZero && Number(value) === 0)

    if (isNoValue) {
        return <Table.Cells.NoValueCell isRightAligned={true} />
    }

    let renderedValue = String(value)

    if (type === "currency") {
        renderedValue = formatCurrency(value)
    } else if (type === "duration") {
        renderedValue = formatDuration(Number(value))
    } else if (type === "percentage") {
        renderedValue = `${value}%`
    } else if (type === "value-hour") {
        const formattedPrice = formatCurrency(value)

        const suffix = unitType === "Hourly" ? "/hr" : ""

        renderedValue = `${formattedPrice}${suffix}`
    }

    return (
        <div className={clsx(styles.base, styles[`${type}Type`], { [styles.alerting]: isAlerting })}>
            {renderedValue}
        </div>
    )
}
